import { cloneDeep, isNull, merge } from 'lodash';
import { OnInit, Input, Component, Output, EventEmitter } from "@angular/core";

interface IHandle {
  color?: string;
  inputMargin: number;
}

interface IHandles {
  from: IHandle;
  to: IHandle;
}

interface ThresholdValue {
  valueFrom: number;
  valueTo: number;
}

@Component({
  selector: "threshold-widget",
  templateUrl: "./threshold.widget.template.html",
  styleUrls: ["./threshold.widget.scss"]
})
export class ThresholdWidgetComponent implements OnInit {
  @Input()
  threshold: {
    kpiName: string;
    friendlyName: string;
    dimensionValue: string;
    minValue: number;
    maxValue: number;
    precisionValue: number;
    valueFrom: number;
    valueTo: number;
    nameFrom: string;
    nameTo: string;
    singleSlider: boolean;
    readonly: boolean;
    siteName: string;
    appName: string;
    units: string;
  };
 
  
  @Output() updateThresholdEvent?: EventEmitter<any> = new EventEmitter();

  description: string;

  options: {
    id: string;
    domain: Array<number>;
    unit: string;
    handles: any;
    precision: number;
    readOnly: boolean;
  };

  ngOnInit() {
    this.options = {
      id: this.name,
      domain: this.domain,
      unit: this.unit,
      handles: this.handles,
      precision: this.precision,
      readOnly: this.readOnly
    };
    this.populateDescription();
  }

  populateDescription() {
    if(this.threshold.dimensionValue === "site") {
      this.description = "The following thresholds will override the default site thresholds";
    }
    else if(this.threshold.dimensionValue === "app") {
      this.description = "The following thresholds will override the default application thresholds";
    }
    else if(this.threshold.dimensionValue === "appSite") {
      this.description = "The following thresholds will override the default application within site thresholds";
    }
  }

  get name(): string {
    return this.threshold.friendlyName;
  }

  get unit(): string {
    return  this.threshold.units;;
  }

  get precision(): number {
    return this.threshold.precisionValue;
  }

  get min(): number {
    return this.threshold.minValue;
  }

  get max(): number {
    return this.threshold.maxValue;
  }

  get domain(): Array<number> {
    return [this.max, this.min];
  }

  get readOnly(): boolean {
    return this.threshold.readonly;
  }

  get showFrom() : boolean {
    return !isNull(this.threshold.valueFrom)
  }

  get showTo() : boolean {
    return !isNull(this.threshold.valueTo)
  }


  get handles(): IHandles {
    return {
      from: this.getHandle(this.threshold.nameFrom),
      to: this.getHandle(this.threshold.nameTo, {
        inputMargin: -22
      })
    };
  }

  getHandle(name: string, hOptions?: IHandle): IHandle {
    return merge(
      {
        color: this.getColor(name)
      },
      hOptions
    );
  }

  getColor(name: string): string {
    if (name === "critical") {
      return "rgb(217, 0, 7)";
    }
    return "rgb(239, 169, 41)";
  }


  setThreshold(newVal: ThresholdValue): void {
    if (this.updateThresholdEvent) {
      this.updateThresholdEvent.emit((cloneDeep(this.threshold), newVal));
    }
    this.threshold.valueFrom = newVal.valueFrom;
    if(!this.threshold.singleSlider){
      this.threshold.valueTo = newVal.valueTo;
    }
  }
}
